import React, { Component } from "react";
import { compose } from "redux";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { showLoader } from "./../../redux/actions/action_loader";
import Grid from "@material-ui/core/Grid";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Typography from "@material-ui/core/Typography";
import Checkbox from "@material-ui/core/Checkbox";
// import Button from "@material-ui/core/Button";
// import axios from "axios";
import { getApiData } from "./../../api/api";
import "./Declaration.css";
import { disclaimerText } from "./../../utils/disclaimerText";
import { getDevice } from "./../../utils/getDevice";
import { withTranslation } from "react-i18next";
import AxiosRequest from "../../utils/axios";
import { getOTPDeclarationFromStorage } from "../../utils/handleData";
import { DECLRATION_IDS, YES } from "../../utils/constants";
import { getUserLang } from "../../utils/handleVoiceAndLang";
import { Button } from "unified-ui-components-library";

const axios = new AxiosRequest().getClient()

class Declaration extends Component {
  constructor() {
    super();
    this.state = {
      checked: false,
      proceeding: false,
      ulipStatus: localStorage.getItem("ulipStatus"),
      cis: localStorage.getItem("cis")
    };
  }

  componentDidMount() {
    this.props.showLoader(false);
  }

  handleChange = (checked) => {
    this.setState({ checked });
  };

  proceed = async () => {
    this.props.showLoader(true);
    await this.setState({ proceeding: true });
    const { url, body } = getApiData("declaration");
    body.request.payload.customerDisclaimer = "Agreed";

    try {
      await axios.post(url, body);
      this.setState({ proceeding: false }, () => {
        this.props.history.push("/generate_otp");
      });
    } catch (err) {
      this.setState({ proceeding: false });
      this.handleSnackbar(
        true,
        "error",
        "Something went wrong. Please try again"
      );
    } finally {
      this.props.showLoader(false);
    }
  };

  handleSnackbar = (showSnackbar, snackbarMsgType, snackbarMsg) => {
    const options = { showSnackbar, snackbarMsgType, snackbarMsg };
    this.props.showMessageInScackbar(options);
  };

  render() {
    const device = getDevice();
    const declarationClass =
      device === "desktop" ? "cstm-wrap_declaration" : "";
    const buttonStyle = { paddingBottom: device === "mobile" ? "10%" : "auto" };

    return (
      <Grid container justify="center" className={declarationClass}>
        <Grid item xs={12} sm={8}>
          <Card style={{ padding: "8px" }}>
            <CardContent>
              <h4 style={{ textAlign: "center" }}>{this.props.t("Declaration")}</h4>
              <Typography variant="body2" color="textSecondary" component="p">
                {getOTPDeclarationFromStorage(this.state.cis === YES ? DECLRATION_IDS.CIS_DISCLAIMER_TEXT : DECLRATION_IDS.DISCLAIMER_TEXT)[getUserLang()]}
              </Typography>
              {/* {this.state.ulipStatus=="Yes"? <Typography variant="body2" color="textSecondary" component="p" >
              {this.props.t(`${ulipDisclaimerText}`)}
              </Typography>
:null} */}

              <Checkbox
                value={this.state.checked}
                onChange={(event) => this.handleChange(event.target.checked)}
                color="default"
                disabled={this.state.proceeding}
              />
              <label>{this.props.t("I agree")}</label>

              <div className="button_div_unified" style={buttonStyle}>
                <Button
                  variant="contained"
                  onClick={this.proceed}
                  // className="default_button"
                  disabled={!this.state.checked || this.state.proceeding}
                  buttonType="primary"
                  width='264'
                >
                  {this.props.t("Proceed")}
                </Button>
              </div>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    );
  }
}

export default compose(
  withRouter,
  connect(null, { showLoader }),
  withTranslation()
)(Declaration);
